export default __webpack_public_path__ + "static/media/fuegosGeni.37bfa08b.jpg";